@if (title() && cards(); as cards) {
  <wl-information-card-row
    [title]="title()!"
    [content]="content()"
    [cards]="cards"
  ></wl-information-card-row>
}
